import { dataShoppingBagSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShoppingBagSolid = /*#__PURE__*/createIcon(dataShoppingBagSolid)
export default IconShoppingBagSolid
